export default {
    headerParagraph:
        'Welcome to the plans page. Please choose the plan that suits you so that you can enhance your experience and find your correct partner',
    activate: 'Activate plan',
    firstPlanTitle: 'First plan',
    firstPlanP1: '1 year subscription.',
    firstPlanP2: 'Special offer, join now and receive an additional 6 months free of charge.',
    firstPlanPrice: '150 dollars',
    secondPlanTitle: 'Second plan',
    secondPlanP1: '6 months subscription.',
    secondPlanP2: 'Special offer, join now and receive an additional 3 months free of charge.',
    secondPlanPrice: '100 dollars'
}
